import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-doc-functions-widget',
  templateUrl: './doc-functions-widget.component.html',
  styleUrls: ['./doc-functions-widget.component.scss']
})
export class DocFunctionsWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
